
import { useEffect, useState } from "react";
import { useFetchDomainContentAnalysisProcessQuery } from "../../service";



export default function useContentAnalysisProgress(domain: string) {
    const [hasActiveProcess, setHasActiveProcess] = useState<boolean>(false);
    const [processGuid, setProcessGuid] = useState<string | null>(null);

    const { data: domainContentAnalysisProcess, isLoading, error, isError } = useFetchDomainContentAnalysisProcessQuery(
        { domain, processGuid },
        {
            pollingInterval: hasActiveProcess ? 10_000 : 0,
            refetchOnMountOrArgChange: true,
        }
    );

    const websiteProfile = domainContentAnalysisProcess?.output?.website_profile || null;
    const contentEffectiveness = domainContentAnalysisProcess?.output?.content_effectiveness || null;
    const competitorContent = domainContentAnalysisProcess?.output?.competitor_content || null;
    const contentTrust = domainContentAnalysisProcess?.output?.content_trust || null;
    const analysisError = domainContentAnalysisProcess?.output?.error || null;

    useEffect(() => {
        // We didn't have an active process but now we do        
        if (domainContentAnalysisProcess && hasActiveProcess === false) {
            setHasActiveProcess(true);
            setProcessGuid(domainContentAnalysisProcess.guid);
        }

        // Active process completed
        if (domainContentAnalysisProcess && domainContentAnalysisProcess.status === "completed" && hasActiveProcess === true) {
            setHasActiveProcess(false);
            setProcessGuid(null);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainContentAnalysisProcess]);

    return {
        activeProcess: {
            websiteProfile: websiteProfile,
            contentEffectiveness: contentEffectiveness,
            competitorContent: competitorContent,
            contentTrust: contentTrust,
        },
        analysisError: analysisError,
        isLoading,
        error,
        isError,
        hasActiveProcess
    };
}
